import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { toast } from 'react-toastify'
import DirectionsControl from './Directions'
// import IsochronesControl from './Isochrones'
import AnalyzeControl from './Analyze'
import DirectionOutputControl from './Directions/OutputControl'
import AnalyzeOutputControl from './Analyze/OutputControl'
import AdminPanel from 'components/AdminPanel'
import { Segment, Tab, Button, Icon } from 'semantic-ui-react'
import {
  updateTab,
  updateProfile,
  updatePermalink,
  zoomTo,
  resetSettings,
  toggleDirections,
} from 'actions/commonActions'
import { fetchReverseGeocodePerma } from 'actions/directionsActions'
import { VALHALLA_OSM_URL } from 'utils/valhalla'

import { withAuth } from 'utils/withAuth'

const pairwise = (arr, func) => {
  let cnt = 0
  for (let i = 0; i < arr.length - 1; i += 2) {
    func(arr[i], arr[i + 1], cnt)
    cnt += 1
  }
}

class MainControl extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    message: PropTypes.object,
    activeDataset: PropTypes.string,
    activeTab: PropTypes.number,
    showDirectionsPanel: PropTypes.bool,
    lastUpdate: PropTypes.object,
    auth: PropTypes.object,
    userContext: PropTypes.object,
  }

  getIsStaff = () => {
    const globalRole = this.props.userContext?.globalRole
    return globalRole === 'MANAGER' || globalRole === 'SYSTEM_ADMIN'
  }

  async getLastUpdate() {
    let authHeaders = {}
    if (
      this.props.auth &&
      (VALHALLA_OSM_URL.includes('drivepoints.com') ||
        VALHALLA_OSM_URL.includes('localhost'))
    ) {
      authHeaders = {
        Authorization: `Bearer ${this.props.auth?.user?.access_token}`,
      }
    }

    const response = await fetch(`${VALHALLA_OSM_URL}/status`, {
      headers: authHeaders,
    })

    const data = await response.json()
    this.setState({
      lastUpdate: new Date(data.tileset_last_modified * 1000),
    })
  }

  componentDidMount = () => {
    const { dispatch } = this.props

    this.getLastUpdate()

    const activeElement = document.activeElement
    toast.success(
      'Welcome to Drivepoints! A Safer Routing Service for Drivers',
      {
        position: 'bottom-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        autoFocus: false,
      }
    )
    if (activeElement && typeof activeElement.focus === 'function') {
      setTimeout(() => {
        if (document.activeElement !== activeElement) {
          activeElement.focus()
        }
      }, 0)
    }

    const params = Object.fromEntries(new URL(document.location).searchParams)

    if ('profile' in params) {
      dispatch(updateProfile({ profile: params.profile }))
    }

    let activeTab
    if (
      window.location.pathname === '/' ||
      window.location.pathname === '/directions'
    ) {
      activeTab = 0
      dispatch(updateTab({ activeTab }))
    } else if (window.location.pathname === '/analyze') {
      activeTab = 1
      dispatch(updateTab({ activeTab }))
    } else if (window.location.pathname === '/admin') {
      activeTab = this.getIsStaff() ? 2 : 0
      if (!this.getIsStaff()) {
        window.history.replaceState(null, null, '/')
      }
      dispatch(updateTab({ activeTab }))
    }

    if ('wps' in params && params.wps.length > 0) {
      const coordinates = params.wps.split(',').map(Number)
      const processedCoords = []
      pairwise(coordinates, (current, next, i) => {
        const latLng = { lat: next, lng: current }
        const payload = {
          latLng,
          fromPerma: true,
          permaLast: i === coordinates.length / 2 - 1,
          index: i,
        }
        processedCoords.push([latLng.lat, latLng.lng])
        if (activeTab === 0) {
          dispatch(fetchReverseGeocodePerma(payload, this.props.auth))
        }
        // activeTab === 1 (Analyze) doesn't need special handling here
      })
      dispatch(zoomTo(processedCoords))
      dispatch(resetSettings())
    }
  }

  componentDidUpdate = (prevProps) => {
    const { message } = this.props
    if (message.receivedAt > prevProps.message.receivedAt) {
      const activeElement = document.activeElement
      toast[message.type](message.description, {
        position: 'bottom-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        autoFocus: false,
      })
      if (activeElement && typeof activeElement.focus === 'function') {
        setTimeout(() => {
          if (document.activeElement !== activeElement) {
            activeElement.focus()
          }
        }, 0)
      }
    }
  }

  handleTabChange = (event, data) => {
    const { dispatch } = this.props
    const activeTab = data.activeIndex

    if (activeTab === 2 && !this.getIsStaff()) {
      dispatch(updateTab({ activeTab: 0 }))
      window.history.replaceState(null, null, '/')
      return
    }

    dispatch(updateTab({ activeTab }))
    dispatch(updatePermalink())
  }

  handleDirectionsToggle = (event, data) => {
    const { dispatch } = this.props
    const { showDirectionsPanel } = this.props
    if (!showDirectionsPanel) {
      document
        .getElementsByClassName('heightgraph-container')[0]
        .setAttribute('width', window.innerWidth * 0.75)
    } else {
      document
        .getElementsByClassName('heightgraph-container')[0]
        .setAttribute('width', window.innerWidth * 0.9)
    }
    dispatch(toggleDirections())
  }

  render() {
    const { activeTab } = this.props
    const isAdminTab = activeTab === 2
    const isStaff = this.getIsStaff()
    const appPanes = [
      {
        menuItem: 'Directions',
        render: () => (
          <Tab.Pane style={{ padding: '0 0 0 0' }} attached={false}>
            <DirectionsControl />
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Analyze',
        render: () => (
          <Tab.Pane style={{ padding: '0 0 0 0' }} attached={false}>
            <AnalyzeControl />
          </Tab.Pane>
        ),
      },
      // {
      //   menuItem: 'Isochrones',
      //   render: () => (
      //     <Tab.Pane style={{ padding: '0 0 0 0' }} attached={false}>
      //       <IsochronesControl />
      //     </Tab.Pane>
      //   ),
      // },
    ]

    if (isStaff) {
      appPanes.push({
        menuItem: 'Admin',
        render: () => (
          <Tab.Pane style={{ padding: '0 0 0 0' }} attached={false}>
            <AdminPanel
              auth={this.props.auth}
              userContext={this.props.userContext}
            />
          </Tab.Pane>
        ),
      })
    }

    const ServiceTabs = () => (
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          width: '100%',
          gap: '8px',
        }}
      >
        <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
          <Tab
            activeIndex={activeTab}
            onTabChange={this.handleTabChange}
            menu={{ pointing: true }}
            panes={appPanes}
            style={{ width: '100%' }}
          />
        </div>
        <Button
          icon
          style={{ flexShrink: 0, marginTop: '0.5em', padding: '0.78571429em' }}
          onClick={this.handleDirectionsToggle}
        >
          <Icon name="close" />
        </Button>
      </div>
    )

    return (
      <>
        <Button
          primary
          style={{
            zIndex: 998,
            top: '10px',
            left: '10px',
            position: 'absolute',
          }}
          onClick={this.handleDirectionsToggle}
        >
          {activeTab === 0
            ? 'Directions'
            : activeTab === 1
            ? 'Analyze'
            : activeTab === 2
            ? 'Admin'
            : 'Directions'}
        </Button>
        <Drawer
          enableOverlay={false}
          open={this.props.showDirectionsPanel}
          direction="left"
          size={isAdminTab ? '100vw' : '400'}
          style={{
            zIndex: 1000,
            overflow: 'auto',
            maxWidth: isAdminTab ? '100vw' : '400px',
            width: isAdminTab ? '100vw' : '400px',
          }}
        >
          <div
            style={{
              maxWidth: isAdminTab ? '100%' : '400px',
              width: '100%',
              overflow: 'hidden',
            }}
          >
            <Segment
              basic
              style={{ paddingBottom: 0, maxWidth: '100%', padding: '0.5em' }}
            >
              <div
                style={{ maxWidth: '100%', overflow: 'hidden', width: '100%' }}
              >
                <ServiceTabs />
              </div>
            </Segment>
            {activeTab === 0 && <DirectionOutputControl />}
            {activeTab === 1 && <AnalyzeOutputControl />}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              margin: '1rem',
            }}
          >
            Last Data Update:{' '}
            {this.state
              ? `${this.state.lastUpdate
                  .toISOString()
                  .slice(0, 10)}, ${this.state.lastUpdate
                  .toISOString()
                  .slice(11, 16)}`
              : '0000-00-00, 00:00'}
          </div>
        </Drawer>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  const { message, activeTab, showDirectionsPanel } = state.common
  return {
    message,
    activeTab,
    showDirectionsPanel,
  }
}

export default connect(mapStateToProps)(withAuth(MainControl))
